import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeBillingMaintenanceBanner } from '../billing_maintenance_banner_slice';
import { isVisibleSelector } from '../selectors';
const closeButtonCss = "c59625n";
const CloseButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)} />);
const messageIsPhoneCss = "mfs6suv";
const messageCss = "m1mi7ezz";
const Message = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(messageCss, {
    [messageIsPhoneCss]: isPhone
  }, props.className)} />;
});
const titleIsPhoneCss = "tgeuqi6";
const titleCss = "tyi321k";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(titleCss, {
    [titleIsPhoneCss]: isPhone
  }, props.className)} />;
});
const bannerIsPhoneCss = "b1iya3ca";
const bannerCss = "bvrsb3t";
const Banner = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <FixedContainer ref={ref} {...props} className={classNames(bannerCss, {
    [bannerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const BillingMaintenanceBanner = () => {
  const dispatch = useDispatch();
  const title = I18n.t('publisher.billing.stages.undergoing_maintenance.title');
  const message = I18n.t('publisher.billing.stages.undergoing_maintenance.message');
  const isVisible = useSelector(isVisibleSelector);
  if (!isVisible) return null;
  return <Banner data-component="dismissable-billing-maintenance-banner">
      <div>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </div>
      <CloseButton onClick={() => dispatch(closeBillingMaintenanceBanner())} aria-label={I18n.t('publisher.action.close')}>×</CloseButton>
    </Banner>;
};

require("./billing_maintenance_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./billing_maintenance_banner.js");